import { omitBy, isNil, map} from 'lodash';

interface OrderObj {
    trackingNumber: string;
    _id: string;
    orderCode: string;
}

const response = (data) => {
    let looseParcelList: OrderObj[] =[];
    let bulkParcelList: OrderObj[]=[];

    map(data.parcelData, (parcel)=>{
        if(parcel.looseOrders == true){
            looseParcelList.push(parcel)
        }else if (parcel.orderType == "BULK"){
            bulkParcelList.push(parcel)
        }
    })

    const normalizedResponse = {...data, looseParcelList, bulkParcelList}

    return normalizedResponse
}

export default response